import { createStyles } from '@material-ui/styles';
const CONTROL_SIZE = 16;
const INDICATOR_SIZE = 4;
const INDICATOR_SIZE_ACTIVE = 25;
const styles = (theme) => createStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    content: {
        paddingRight: theme.space.padding.smallest,
        paddingLeft: theme.space.padding.smallest,
        flex: '1 1 auto',
        minWidth: 0,
    },
    contentVerticalPadding: {
        paddingTop: theme.space.padding.small,
        paddingBottom: theme.space.padding.small,
    },
    control: {
        boxSizing: 'content-box',
        paddingLeft: theme.space.padding.smallest,
        paddingRight: theme.space.padding.smallest,
        fontSize: CONTROL_SIZE,
        width: CONTROL_SIZE,
        height: CONTROL_SIZE,
        textAlign: 'center',
        display: 'inline-block',
        cursor: 'pointer',
        flex: '0 0 auto',
        '&:hover:not($controlDisabled)': {
            opacity: 0.7,
        },
    },
    controlDisabled: {
        cursor: 'default',
        opacity: 0.38,
    },
    controlIcon: {
        fontSize: CONTROL_SIZE,
        color: 'inherit',
    },
    indicators: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.space.margin.small,
        marginBottom: theme.space.margin.small,
    },
    indicatorDot: {
        width: INDICATOR_SIZE,
        height: INDICATOR_SIZE,
        background: 'black',
        display: 'inline-block',
        borderRadius: INDICATOR_SIZE / 2,
        transition: 'width 0.3s',
        marginLeft: INDICATOR_SIZE / 2,
        marginRight: INDICATOR_SIZE / 2,
    },
    indicatorDotActive: {
        width: INDICATOR_SIZE_ACTIVE,
    },
});
export default styles;
//# sourceMappingURL=CarouselCardStyle.js.map